module.exports = __webpack_public_path__ + "static/media/william-iven-jrh5lAq-mIs-unsplash.becfd116.jpg";